// 清理markdown文本
export const cleanMarkdownText = (text: string): string => {
  return (
    text
      // 保留代码块内容，但移除markdown标记
      .replace(/```[\s\S]*?```/g, (match) => match.replace(/```/g, '').trim())
      // 保留行内代码内容
      .replace(/`([^`]+)`/g, '$1')
      // 处理带标题的链接：如果标题为空或是URL则整个移除，否则保留标题文本
      // 处理空文本的markdown链接 [](url)
      .replace(/\[\]\([^)]+\)/g, '')
      // 处理链接文本与URL相同的情况 [url](url)
      .replace(/\[(?:https?:\/\/[^\]]+)\]\([^)]+\)/g, '')
      // 处理普通markdown链接 [text](url)
      .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
      // 处理纯链接文本，直接移除
      .replace(/(?<![\[\(])(https?:\/\/[^\s]+)(?![\]\)])/g, '')
      // 移除图片标记
      .replace(/!\[([^\]]*)\]\([^)]+\)/g, '')
      // 移除标题标记
      .replace(/^#{1,6}\s+/gm, '')
      // 移除列表标记
      .replace(/^[*-]\s+/gm, '')
      // 移除引用标记
      .replace(/^>\s+/gm, '')
      // 移除水平分隔线
      .replace(/^[-*_]{3,}\s*$/gm, '')
      // 移除强调标记
      .replace(/(\*\*|__)(.*?)\1/g, '$2') // 处理粗体
      .replace(/(\*|_)(.*?)\1/g, '$2') // 处理斜体
      // 移除HTML标签
      .replace(/<[^>]+>/g, '')
      // 处理常见的HTML实体编码
      .replace(/&nbsp;/g, ' ')
      .replace(/&#x20;/g, ' ')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      // 处理其他特殊Unicode空格字符
      .replace(/[\u00A0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000\uFEFF]/g, ' ')
      // 处理零宽字符
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      // 规范化空白字符，但保留换行符
      .replace(/[^\S\r\n]+/g, ' ')
      // 移除表格分隔行 (优化处理)
      .replace(/^\|?[\s\-:|]+\|?$/gm, '')
      // 处理表格内容行，保留单元格文本并用逗号分隔
      .replace(/^\|?(.*?)\|?$/gm, (_, content) =>
        content
          .split('|')
          .map((cell: string) => cell.trim())
          .filter(Boolean) // 过滤掉空字符串
          .join(',')
      )
      // 清理空单元格可能出现连续的逗号
      .replace(/,+/g, ',')
      .trim()
  );
};

// 流式输出分句
export const splitIntoSentences = (text: string, lastProcessedIndex: number = 0): [string[], number] => {
  const endPunctuations = ['。', '！', '？', '!', '?', '.', '\n'];
  const sentences: string[] = [];
  let currentSentence = '';

  for (let i = lastProcessedIndex; i < text.length; i++) {
    const char = text[i];
    currentSentence += char;

    if (endPunctuations.includes(char)) {
      // 检查是否在URL中
      const beforeChar = text.slice(Math.max(0, i - 100), i); // 获取前面的文本进行URL检查
      const isInUrl = /https?:\/\/[^\s]*$/.test(beforeChar);

      if (isInUrl) {
        continue;
      }

      // 特殊处理英文句点的情况
      if (char === '.') {
        const prevChar = text[i - 1] || '';
        const nextChar = text[i + 1] || '';
        const prevTwoChars = text.slice(i - 2, i);

        // 改进小数点和序号的判断逻辑
        if (
          (/\d/.test(prevChar) && /[\d\s]/.test(nextChar)) || // 数字相关（小数点或序号）
          (/[A-Za-z]/.test(prevChar) && /[A-Za-z\s]/.test(nextChar)) || // 缩写
          nextChar === '.' || // 省略号
          /^\d+$/.test(prevTwoChars) // 序号格式
        ) {
          continue;
        }
      }

      // 改进序号判断逻辑
      const isNumberingOnly = /^\d+[.．、:：]\s*$/.test(currentSentence.trim());
      const isValidSentence = currentSentence.trim().length > 0 && !isNumberingOnly;

      if (isValidSentence) {
        sentences.push(currentSentence.trim());
        currentSentence = '';
        lastProcessedIndex = i + 1;
      }
    }
  }
  return [sentences, lastProcessedIndex];
};
